import { useEffect, useState } from "react";
import { Link } from 'react-router-dom';
import Footer from "./Footer";
import "./Dzyris.css";
import bg1 from "../img/seekh.png";
import bg2 from "../img/ZINGER.png";
import Header from "./Header";
// Extracted MenuItem component for better reusability
// Make sure to add 'onImageClick' to the destructuring of props here

function MenuItem({ image, name, price, description, quantity, orderLink, onImageClick }) {
    return (
        <div className="col-lg-6">
            <div className="d-flex align-items-center">
                <img
                    src={image}
                    alt={name}
                    className="modal-trigger"
                    style={{ width: '80px', cursor: 'pointer' }}
                    onClick={() => onImageClick(image, name)} // Call onImageClick when image is clicked
                />
                <div className="w-100 d-flex flex-column text-start ps-4">
                    <h5 className="d-flex justify-content-between border-bottom pb-2">
                        <span>{name}</span>
                        <span className="text-primary">{price}</span>
                    </h5>
                    <small className="fst-italic">{description}</small>
                    {quantity && <large className="fst" style={{ color: 'crimson' }}> <strong>{quantity}</strong></large>}
                    <a
                        href={orderLink}
                        className="btn btn-primary px-2 py-1"
                        style={{ fontSize: '12px', borderRadius: '4px' }}
                    >
                        Order Now
                    </a>
                </div>
            </div>
        </div>
    );
}

let isConnecting = false;

async function connectWallet() {
  if (isConnecting) return;
  isConnecting = true;

  try {
    await window.ethereum.request({ method: 'eth_requestAccounts' });
  } finally {
    isConnecting = false;
  }
}

// ImageModal Component (defined directly within Dzyris.js)
function ImageModal({ imageUrl, imageName, onClose }) {
    if (!imageUrl) return null;
    return (
        <div className="image-modal-overlay" onClick={onClose}>
            <div className="image-modal-content" onClick={(e) => e.stopPropagation()}>
                <button className="image-modal-close-button" onClick={onClose}>&times;</button>
                <img src={imageUrl} alt={imageName} className="enlarged-image" />
                {imageName && <p className="image-modal-caption">{imageName}</p>}
            </div>
        </div>
    );
}

function Dzyris() {
    const [isLogoVisible, setIsLogoVisible] = useState(false);
    const [modalImage, setModalImage] = useState(null);
    const [modalImageName, setModalImageName] = useState('');

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 50) {
                setIsLogoVisible(true);
            } else {
                setIsLogoVisible(false);
            }
        };
        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    // Handler function to open the modal
    const handleImageClick = (image, name) => {
        setModalImage(image);
        setModalImageName(name);
    };

    // Handler function to close the modal
    const handleCloseModal = () => {
        setModalImage(null);
        setModalImageName('');
    };

    const vegItems = [
        {
            image: 'Veg Burger Patty.png',
            name: 'Veg Burger Patty',
            price: 'MRP ₹ 320/-',
            description: 'Crispy potato patties seasoned with the perfect blend of spices. A beloved Indian snack that never fails to delight!',
            quantity: '1 Kg (Approx. 17 Pcs)',
            orderLink: 'https://frozen.dzyris.in/?guest=true&restaurantId=682db56b038ddec1b8527d1c',
        },
        {
            image: 'Cheese Corn nuggets.png',
            name: 'Cheese Corn Nuggets',
            price: 'MRP ₹ 690/-',
            description: "Golden nuggets filled with sweet corn and melted cheese-a vegetarian delight that's irresistible!",
            quantity: '1 Kg (Approx. 40 Pcs)',
            orderLink: 'https://frozen.dzyris.in/?guest=true&restaurantId=682db56b038ddec1b8527d1c',
        },
        {
            image: 'Paneer patty.png',
            name: 'Paneer Patty',
            price: 'MRP ₹ 495/-',
            description: 'Soft, spongy paneer patty bursting with flavors. Ideal for a delicious vegetarian burger or a protein-packed meal!',
            quantity: '1 Kg (Approx. 14 Pcs)',
            orderLink: 'https://frozen.dzyris.in/?guest=true&restaurantId=682db56b038ddec1b8527d1c',
        },
        {
            image: 'Corn Cheese patty.png',
            name: 'Corn Cheese Patty',
            price: 'MRP ₹ 750/-',
            description: 'Creamy mix of corn and cheese, shaped into a patty and lightly fried-an indulgent treat for cheese enthusiasts!',
            quantity: '1 Kg (Approx. 15 Pcs)',
            orderLink: 'https://frozen.dzyris.in/?guest=true&restaurantId=682db56b038ddec1b8527d1c',
        },
        {
            image: 'VEg Nuggets.png',
            name: 'Veg Nuggets',
            price: 'MRP ₹ 450/-',
            description: 'Crispy and delicious vegetable nuggets-a healthy and tasty alternative for vegetarians. Perfect for snacking or salads!',
            quantity: '1 Kg (Approx. 40 Pcs)',
            orderLink: 'https://frozen.dzyris.in/?guest=true&restaurantId=682db56b038ddec1b8527d1c',
        },
        {
            image: 'Crispy Vegg patty.png',
            name: 'Crispy Veg Patty',
            price: 'MRP ₹ 400/-',
            description: 'A medley of vegetables fried until crispy-ideal for veggie burgers or quick snack. A delicious way to add veggies to your diet!',
            quantity: '1 Kg (Approx. 15 Pcs)',
            orderLink: 'https://frozen.dzyris.in/?guest=true&restaurantId=682db56b038ddec1b8527d1c',
        },
        {
            image: 'Alootikki.jpg',
            name: 'Aloo Tikki',
            price: 'MRP ₹ 300/-',
            description: 'A bold and spicy fusion for those who love a little heat in their meals-experience the thrill of fiery flavours!',
            quantity: '1 Kg (Approx. 20 Pcs)',
            orderLink: 'https://frozen.dzyris.in/?guest=true&restaurantId=682db56b038ddec1b8527d1c',
        },
        {
            image: 'Harabhara kabab patty.png',
            name: 'Harabhara Kabab Patty',
            price: 'MRP ₹ 475/-',
            description: 'A nutritious and flavorful patty made with spinach, peas, and spices-a healthy option for vegetarian burgers!',
            quantity: '1 Kg (Approx. 15 Pcs)',
            orderLink: 'https://frozen.dzyris.in/?guest=true&restaurantId=682db56b038ddec1b8527d1c',
        },
        {
            image: 'Lebanese falal.png',
            name: 'Lebanese Falafel',
            price: 'MRP ₹ 475/-',
            description: 'An extra-large treat for those extra-large cravings-enjoy the rich, satisfying flavor of this unique chickpeas creations!',
            quantity: '1 Kg (Approx. 17 Pcs)',
            orderLink: 'https://frozen.dzyris.in/?guest=true&restaurantId=682db56b038ddec1b8527d1c',
        },
        {
            image: 'french fries.png',
            name: 'Chill Fill French Fries',
            price: 'MRP ₹ 650/-',
            description: 'An extra-large treat for those extra-large cravings-enjoy the rich, satisfying flavor of this unique chickpeas creations!',
            quantity: '2.5 Kg',
            orderLink: 'https://frozen.dzyris.in/?guest=true&restaurantId=682db56b038ddec1b8527d1c',
        },
        {
            image: 'malabar.png',
            name: 'Malabar Paratha',
            price: 'MRP ₹ 250/-',
            description: 'Layered to perfection and irresistibly flaky—Malabar Paratha is a buttery, golden delight that melts in your mouth and pairs perfectly with every curry craving!',
            quantity: '5 Per pack',
            orderLink: 'https://frozen.dzyris.in/?guest=true&restaurantId=682db56b038ddec1b8527d1c',
        },
        {
            image: 'pizza.png',
            name: 'Cheese Pizza',
            price: 'MRP ₹ 200/-',
            description: 'Oozing with molten cheese and baked to golden perfection—our Cheese Pizza is a mouthwatering classic that satisfies every slice of your craving!',
            quantity: '6 Inch',
            orderLink: 'https://frozen.dzyris.in/?guest=true&restaurantId=682db56b038ddec1b8527d1c',
        },
    ];

    // --- New Data for Non-Veg Items ---
    const nonVegItems = [
        {
            "image": "Chicken Popcorn.png",
            "name": "Chicken Popcorn",
            "mrp": "₹ 850/-",
            "description": "Crispy, bite-sized pieces of tender chicken seasoned to perfection perfect for any time of the day or on-the-go snacking!",
            "weight_and_pieces": "1 Kg (Approx. 125 Pcs)",
            orderLink: "https://frozen.dzyris.in/?guest=true&restaurantId=682db56b038ddec1b8527d1c"
        },
        {
            "image": "Crispy Chicken Fillet.png",
            "name": "Crispy Chicken Fillet",
            "mrp": "₹ 850/-",
            "description": "Juicy chicken fillets in a crunchy coating-ideal for a quick meal or adding to burgers for a satisfying treat.",
            "weight_and_pieces": "1 Kg (Approx. 14 Pcs)",
            orderLink: "https://frozen.dzyris.in/?guest=true&restaurantId=682db56b038ddec1b8527d1c"
        },
        {
            "image": "Chicken Strips.png",
            "name": "Chicken Strips",
            "mrp": "₹ 900/-",
            "description": "Succulent chicken breast strips, lightly breaded and fried to a golden crisp-ideal for dipping or as a main dish!",
            "weight_and_pieces": "1 Kg (Approx. 29 Pcs)",
            orderLink: "https://frozen.dzyris.in/?guest=true&restaurantId=682db56b038ddec1b8527d1c"
        },
        {
            "image": "Chicken wings.png",
            "name": "Chicken Wings",
            "mrp": "₹ 950/-",
            "description": "Marinated in our secret blend of spices and cooked to crispy perfection-a guaranteed hit at any gathering!",
            "weight_and_pieces": "1 Kg (Approx. 29 Pcs)",
            orderLink: "https://frozen.dzyris.in/?guest=true&restaurantId=682db56b038ddec1b8527d1c"
        },
        {
            "image": "Super Duper duper.png",
            "name": "Super Duper",
            "mrp": "₹ 600/-",
            "description": "An extra-large treat for those big cravings-satisfy your hunger with the rich flavor of this unique chicken creation!",
            "weight_and_pieces": "1 Kg (Approx. 18 Pcs)",
            orderLink: "https://frozen.dzyris.in/?guest=true&restaurantId=682db56b038ddec1b8527d1c"
        },
        {
            "image": "Kabab patty.png",
            "name": "Kabab Patty",
            "mrp": "₹ 690/-",
            "description": "Savory and spiced to perfection, our chicken kabab patties are versatile and perfect for elevating any meal!",
            "weight_and_pieces": "1 Kg (Approx. 15 Pcs)",
            orderLink: "https://frozen.dzyris.in/?guest=true&restaurantId=682db56b038ddec1b8527d1c"
        },
        {
            "image": "Chicken nuggets.png",
            "name": "Chicken Nuggets",
            "mrp": "₹ 650/-",
            "description": "Classic crispy nuggets that are loved by all ages-perfect for kid's meals or quick snacks!",
            "weight_and_pieces": "1 Kg (Approx. 40 Pcs)",
            orderLink: "https://frozen.dzyris.in/?guest=true&restaurantId=682db56b038ddec1b8527d1c"
        },
        {
            "image": "Malai Roll _ malai kabab.png",
            "name": "Malai Rolls",
            "mrp": "₹ 850/-",
            "description": "Creamy and aromatic chicken rolls infused with exquisite spices-a delightful burst of flavor in every bite!",
            "weight_and_pieces": "1 Kg (Approx. 33 Pcs)",
            orderLink: "https://frozen.dzyris.in/?guest=true&restaurantId=682db56b038ddec1b8527d1c"
        },
        {
            "image": "Chicken Cheese Nuggets.png",
            "name": "Chicken Cheese Nuggets",
            "mrp": "₹ 850/-",
            "description": "Classic nuggets with gooey cheese centers-an indulgent snack that's hard to resist",
            "weight_and_pieces": "1 Kg (Approx. 33 Pcs)",
            orderLink: "https://frozen.dzyris.in/?guest=true&restaurantId=682db56b038ddec1b8527d1c"
        },
        {
            "image": "Malai Tikka.png",
            "name": "Malai Tikka",
            "mrp": "₹ 1050/-",
            "description": "Tender chunks of chicken marinated in a creamy blend of spices and grilled to perfection experience culinary excellence!",
            "weight_and_pieces": "1 Kg (Approx. 29 Pcs)",
            orderLink: "https://frozen.dzyris.in/?guest=true&restaurantId=682db56b038ddec1b8527d1c"
        },
        {
            "image": "Tandoori Chicken Fillet.png",
            "name": "Tandoori Chicken Fillet",
            "mrp": "₹ 1000/-",
            "description": "Flavored with authentic tandoori spices and grilled to perfection experience the taste of traditional tandoori!",
            "weight_and_pieces": "1 Kg (Approx. 14 Pcs)",
            orderLink: "https://frozen.dzyris.in/?guest=true&restaurantId=682db56b038ddec1b8527d1c"
        },
        {
            "image": "cheese balls.png",
            "name": "Chicken Cheese Balls",
            "mrp": "₹ 945/-",
            "description": "Chicken cheese balls are crispy, golden bites filled with seasoned chicken and gooey melted cheese.",
            "weight_and_pieces": "1 Kg (Approx. 33 Pcs)",
            orderLink: "https://frozen.dzyris.in/?guest=true&restaurantId=682db56b038ddec1b8527d1c"
        },
        {
            "image": "Donut-f25936f-sabroso.png",
            "name": "Chicken Donut",
            "mrp": "₹ 790/-",
            "description": "Chicken donuts are crispy, ring-shaped snacks made from seasoned chicken, coated in breadcrumbs, and deep-fried to perfection.",
            "weight_and_pieces": "1 Kg (Approx. 25 Pcs)",
            orderLink: "https://frozen.dzyris.in/?guest=true&restaurantId=682db56b038ddec1b8527d1c"
        },
        {
            "image": "FINGERS.png",
            "name": "Chicken Fingers",
            "mrp": "₹ 540/-",
            "description": "Chicken fingers are crispy, breaded strips of tender chicken, fried or baked to golden perfection.",
            "weight_and_pieces": "1 Kg (Approx. 40 Pcs)",
            orderLink: "https://frozen.dzyris.in/?guest=true&restaurantId=682db56b038ddec1b8527d1c"
        },
        {
            "image": "premium nugets.png",
            "name": "Chicken Premium Nuggets",
            "mrp": "₹ 560/-",
            "description": "Chicken premium nuggets are juicy, high-quality chicken bites coated in a crispy, flavorful breading.",
            "weight_and_pieces": "1 Kg (Approx. 40 Pcs)",
            orderLink: "https://frozen.dzyris.in/?guest=true&restaurantId=682db56b038ddec1b8527d1c"
        },
        {
            "image": "gola.png",
            "name": "Chicken Gola Kebab",
            "mrp": "₹ 570/-",
            "description": "Minced chicken, masterfully spiced and shaped into tender Gola Kebabs!",
            "weight_and_pieces": "1 Kg (Approx. 40 Pcs)",
            orderLink: "https://frozen.dzyris.in/?guest=true&restaurantId=682db56b038ddec1b8527d1c"
        },
        {
            "image": "keema-removebg-preview.png",
            "name": "Malabar Chicken Keema Paratha",
            "mrp": "₹ 500/-",
            "description": "Soft, warm paratha stuffed with spiced minced chicken, creating a savory and satisfying meal.",
            "weight_and_pieces": "5 pcs",
            orderLink: "https://frozen.dzyris.in/?guest=true&restaurantId=682db56b038ddec1b8527d1c"
        }
    ];
    // --- New Data for Seekh Kebab Items ---
    const seekhKebabItems = [
        {
            "image": "malaiseekh.jpg",
            "name": "Malai Seekh",
            "mrp": "₹ 850/-",
            "description": "Creamy, succulent kebab marinated in a rich blend of cream and aromatic spices. Each bite is a tender, melt-in-your-mouth experience with a luxurious flavor!",
            "weight_and_pieces": "1 Kg (Approx. 18 Pcs)",
            orderLink: "https://frozen.dzyris.in/?guest=true&restaurantId=682db56b038ddec1b8527d1c"
        },
        {
            "image": "tandoori.jpg",
            "name": "Tandoori Seekh",
            "mrp": "₹ 850/-",
            "description": "vibrant kebab marinated in a rich blend of tandoori spices, delivering a smoky, charred flavor. Grilled to perfection, it offers a juicy, aromatic taste with every bite!",
            "weight_and_pieces": "1 Kg (Approx. 18 Pcs)",
            orderLink: "https://frozen.dzyris.in/?guest=true&restaurantId=682db56b038ddec1b8527d1c"
        },
        {
            "image": "classic.jpg",
            "name": "Classic Seekh",
            "mrp": "₹ 850/-",
            "description": "Classic Seekh is a timeless kebab, seasoned with traditional spices and herbs. Grilled to perfection, it offers a succulent, savory taste with a perfect balance of flavors!",
            "weight_and_pieces": "1 Kg (Approx. 18 Pcs)",
            orderLink: "https://frozen.dzyris.in/?guest=true&restaurantId=682db56b038ddec1b8527d1c"
        },
        {
            "image": "peri peri.jpg",
            "name": "Peri Peri Seekh",
            "mrp": "₹ 850/-",
            "description": "Peri Peri Seekh packs a fiery punch with its zesty, chili-laden marinade. Each bite delivers a vibrant blend of spice and smoky flavor, perfect for heat lovers!",
            "weight_and_pieces": "1 Kg (Approx. 18 Pcs)",
            orderLink: "https://frozen.dzyris.in/?guest=true&restaurantId=682db56b038ddec1b8527d1c"
        },
        {
            "image": "achari.jpeg",
            "name": "Achari Seekh",
            "mrp": "₹ 650/-",
            "description": "Achari Seekh is a succulent kebab marinated in tangy pickling spices, grilled to smoky perfection. Each bite offers a delicious blend of traditional flavors and tender meat!",
            "weight_and_pieces": "1 Kg (Approx. 18 Pcs)",
            orderLink: "https://frozen.dzyris.in/?guest=true&restaurantId=682db56b038ddec1b8527d1c"
        },
        {
            "image": "lucknowi.jpg",
            "name": "Lucknowee Seekh",
            "mrp": "₹ 650/-",
            "description": "Richly spiced kebab, blending aromatic herbs and tender minced meat. Grilled to perfection, it offers a taste of royal Lucknowi cuisine with every bite!",
            "weight_and_pieces": "1 Kg (Approx. 18 Pcs)",
            orderLink: "https://frozen.dzyris.in/?guest=true&restaurantId=682db56b038ddec1b8527d1c"
        },
        {
            "image": "malaiseekh.jpg",
            "name": "Malai Seekh",
            "mrp": "₹ 650/-",
            "description": "Creamy, succulent kebab marinated in a rich blend of cream and aromatic spices. Each bite is a tender, melt-in-your-mouth experience with a luxurious flavor!",
            "weight_and_pieces": "1 Kg (Approx. 18 Pcs)",
            orderLink: "https://frozen.dzyris.in/?guest=true&restaurantId=682db56b038ddec1b8527d1c"
        },
        {
            "image": "angara.jpeg",
            "name": "Angara Seekh",
            "mrp": "₹ 650/-",
            "description": "Boasts a unique blend of spices and herbs, creating a tender kebab with an aromatic, savory flavor. Grilled to perfection, it offers a deliciously spicy and robust taste!",
            "weight_and_pieces": "1 Kg (Approx. 18 Pcs)",
            orderLink: "https://frozen.dzyris.in/?guest=true&restaurantId=682db56b038ddec1b8527d1c"
        },
        {
            "image": "peri peri.jpg",
            "name": "Peri Peri Seekh",
            "mrp": "₹ 650/-",
            "description": "Peri Peri Seekh packs a fiery punch with its zesty, chili-laden marinade. Each bite delivers a vibrant blend of spice and smoky flavor, perfect for heat lovers!",
            "weight_and_pieces": "1 Kg (Approx. 18 Pcs)",
            orderLink: "https://frozen.dzyris.in/?guest=true&restaurantId=682db56b038ddec1b8527d1c"
        },
        {
            "image": "black pepper.jpg",
            "name": "Black Pepper Seekh",
            "mrp": "₹ 650/-",
            "description": "A bold, peppery kick with each juicy bite. Infused with aromatic spices, it offers a robust and flavorful grilling experience!",
            "weight_and_pieces": "1 Kg (Approx. 18 Pcs)",
            orderLink: "https://frozen.dzyris.in/?guest=true&restaurantId=682db56b038ddec1b8527d1c"
        },
        {
            "image": "schezwan.jpg",
            "name": "Schezwan Seekh",
            "mrp": "₹ 650/-",
            "description": "A fiery blend of Schezwan spices and herbs, creating a bold, tangy flavor. Grilled to perfection, it delivers a spicy kick with every juicy bite!",
            "weight_and_pieces": "1 Kg (Approx. 18 Pcs)",
            orderLink: "https://frozen.dzyris.in/?guest=true&restaurantId=682db56b038ddec1b8527d1c"
        },
        {
            "image": "classic.jpg",
            "name": "Classic Seekh",
            "mrp": "₹ 650/-",
            "description": "Classic Seekh is a timeless kebab, seasoned with traditional spices and herbs. Grilled to perfection, it offers a succulent, savory taste with a perfect balance of flavors!",
            "weight_and_pieces": "1 Kg (Approx. 18 Pcs)",
            orderLink: "https://frozen.dzyris.in/?guest=true&restaurantId=682db56b038ddec1b8527d1c"
        },
        {
            "image": "tandoori.jpg",
            "name": "Tandoori Seekh",
            "mrp": "₹ 650/-",
            "description": "vibrant kebab marinated in a rich blend of tandoori spices, delivering a smoky, charred flavor. Grilled to perfection, it offers a juicy, aromatic taste with every bite!",
            "weight_and_pieces": "1 Kg (Approx. 18 Pcs)",
            orderLink: "https://frozen.dzyris.in/?guest=true&restaurantId=682db56b038ddec1b8527d1c"
        },
        {
            "image": "galauti.jpg",
            "name": "Galauti Seekh",
            "mrp": "₹ 650/-",
            "description": "Exceptionally tender kebab, infused with a blend of aromatic spices and herbs. Each bite melts in your mouth, offering a rich, melt-in-your-mouth flavor experience!",
            "weight_and_pieces": "1 Kg (Approx. 18 Pcs)",
            orderLink: "https://frozen.dzyris.in/?guest=true&restaurantId=682db56b038ddec1b8527d1c"
        },
        {
            "image": "turkish.jpg",
            "name": "Turkish Seekh",
            "mrp": "₹ 650/-",
            "description": "A blend of aromatic Middle Eastern spices and herbs, creating a uniquely flavorful kebab. Grilled to perfection, it offers a savory taste with a hint of exotic flair!",
            "weight_and_pieces": "1 Kg (Approx. 18 Pcs)",
            orderLink: "https://frozen.dzyris.in/?guest=true&restaurantId=682db56b038ddec1b8527d1c"
        },
        {
            "image": "harayali.png",
            "name": "Hariyal Seekh",
            "mrp": "₹ 650/-",
            "description": "Classic Seekh is a timeless kebab, seasoned with traditional spices and herbs. Grilled to perfection, it offers a succulent, savory taste with a perfect balance of flavors!",
            "weight_and_pieces": "1 Kg (Approx. 18 Pcs)",
            orderLink: "https://frozen.dzyris.in/?guest=true&restaurantId=682db56b038ddec1b8527d1c"
        },
        {
            "image": "afghani.png",
            "name": "Afghani Seekh",
            "mrp": "₹ 650/-",
            "description": "Combines tender minced meat with a rich, aromatic blend of spices and herbs. Grilled to perfection, it offers a subtly sweet and smoky flavor with every bite.!",
            "weight_and_pieces": "1 Kg (Approx. 18 Pcs)",
            orderLink: "https://frozen.dzyris.in/?guest=true&restaurantId=682db56b038ddec1b8527d1c"
        }
    ];

    const bestSellerItems = [
        {
            image: 'Veg Burger Patty.png',
            name: 'Veg Burger Patty',
            price: 'MRP ₹ 320/-',
            description: 'Crispy potato patties seasoned with the perfect blend of spices. A beloved Indian snack that never fails to delight!',
            quantity: '1 Kg (Approx. 17 Pcs)',
            orderLink: 'https://frozen.dzyris.in/?guest=true&restaurantId=682db56b038ddec1b8527d1c',
        },
        {
            image: 'Cheese Corn nuggets.png',
            name: 'Cheese Corn Nuggets',
            price: 'MRP ₹ 690/-',
            description: "Golden nuggets filled with sweet corn and melted cheese-a vegetarian delight that's irresistible!",
            quantity: '1 Kg (Approx. 40 Pcs)',
            orderLink: 'https://frozen.dzyris.in/?guest=true&restaurantId=682db56b038ddec1b8527d1c',
        },
        {
            image: 'Paneer patty.png',
            name: 'Paneer Patty',
            price: 'MRP ₹ 495/-',
            description: 'Soft, spongy paneer patty bursting with flavors. Ideal for a delicious vegetarian burger or a protein-packed meal!',
            quantity: '1 Kg (Approx. 14 Pcs)',
            orderLink: 'https://frozen.dzyris.in/?guest=true&restaurantId=682db56b038ddec1b8527d1c',
        },
        {
            image: "Malai Roll _ malai kabab.png",
            name: "Malai Rolls",
            mrp: "₹ 850/-",
            description: "Creamy and aromatic chicken rolls infused with exquisite spices-a delightful burst of flavor in every bite!",
            "weight_and_pieces": "1 Kg (Approx. 33 Pcs)",
            orderLink: "https://frozen.dzyris.in/?guest=true&restaurantId=682db56b038ddec1b8527d1c"
        },
        {
            image: "Chicken Strips.png",
            name: "Chicken Strips",
            mrp: "₹ 900/-",
            description: "Succulent chicken breast strips, lightly breaded and fried to a golden crisp-ideal for dipping or as a main dish!",
            "weight_and_pieces": "1 Kg (Approx. 29 Pcs)",
            orderLink: "https://frozen.dzyris.in/?guest=true&restaurantId=682db56b038ddec1b8527d1c"
        },
        {
            image: "malaiseekh.jpg",
            name: "Malai Seekh",
            mrp: "₹ 850/-",
            description: "Creamy, succulent kebab marinated in a rich blend of cream and aromatic spices. Each bite is a tender, melt-in-your-mouth experience with a luxurious flavor!",
            "weight_and_pieces": "1 Kg (Approx. 18 Pcs)",
            orderLink: "https://frozen.dzyris.in/?guest=true&restaurantId=682db56b038ddec1b8527d1c"
        },
        {
            image: "harayali.png",
            name: "Hariyal Seekh",
            mrp: "₹ 650/-",
            description: "Classic Seekh is a timeless kebab, seasoned with traditional spices and herbs. Grilled to perfection, it offers a succulent, savory taste with a perfect balance of flavors!",
            "weight_and_pieces": "1 Kg (Approx. 18 Pcs)",
            orderLink: "https://frozen.dzyris.in/?guest=true&restaurantId=682db56b038ddec1b8527d1c"
        },
        {
            image: "afghani.png",
            name: "Afghani Seekh",
            mrp: "₹ 650/-",
            description: "Combines tender minced meat with a rich, aromatic blend of spices and herbs. Grilled to perfection, it offers a subtly sweet and smoky flavor with every bite.!",
            "weight_and_pieces": "1 Kg (Approx. 18 Pcs)",
            orderLink: "https://frozen.dzyris.in/?guest=true&restaurantId=682db56b038ddec1b8527d1c"
        }
    ];


    return (
        <>
        <Header/>
            <div className="container-xxxl position-relative p-0">
                {/* <nav className="navbar navbar-expand-lg navbar-dark bg-dark px-4 px-lg-5 py-3 py-lg-0">
                    <a href="index.html" className="navbar-brand p-0">
                        <img
                            src="dzyrislogo.png"
                            alt="Dzyris Frozen Foods Pvt. Ltd"
                            className={`navbar-logo ${isLogoVisible ? 'visible' : ''}`}
                            style={{ height: '70px' }}
                        />
                    </a>
                    <button
                        className="navbar-toggler"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#navbarCollapse"
                    >
                        <span className="fa fa-bars"></span>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarCollapse">
                        <div className="navbar-nav ms-auto py-0 pe-4">
                            <a href="#" className="nav-item nav-link active">Home</a>
                            <Link to="/login" className="btn btn-primary me-2">Login</Link>
                            <Link to="/signup" className="btn btn-primary">Sign Up</Link>
                        </div>
                    </div>
                </nav> */}
            </div>

            <div id="heroCarousel" className="carousel slide" data-bs-ride="carousel" data-bs-interval="2000">
                <div className="carousel-inner">
                    <div className="carousel-item active" data-bs-interval="2000">
                        <div className="slide-background">
                            {/* Make sure the image path here is correct */}
                        </div>
                        <div>
                            {/* <img
                                src="51UJxv24EAL-removebg-preview.png"
                                alt="logo"
                                className="carousel-logo slide1-logo"
                                style={{ position: 'absolute', top: 8, left: 10, width: '8%', height: '13%', zIndex: 1, marginTop: '1%', marginRight: '4%', marginLeft: '40%' }}
                            /> */}
                        </div>
                        <div className="container-xxl py-5 bg-dark hero-header mb-5">
                            <div className="container my-5 py-5">
                                <div className="row align-items-center g-5 hero-row-margin">
                                    <div className="col-lg-6 text-center text-lg-start">
                                        <h1 className="display-5 text-white animated slideInLeft">
                                            Please Login/Register to place order.
                                        </h1>
                                        <h1 className="display-5 text-white animated slideInLeft">
                                            Discover the Joy
                                            <br />
                                            of Delicious, Effortless Meals
                                        </h1>
                                        <p className="text-white animated slideInLeft mb-4 pb-2">
                                            Ensuring Best Quality and Best Taste.
                                            <br /> All departments are committed to better food to better sublimate
                                        </p>
                                        <a
                                            href="https://frozen.dzyris.in/?guest=true&restaurantId=682db56b038ddec1b8527d1c"
                                            className="btn btn-primary py-sm-3 px-sm-5 me-3 animated slideInLeft"
                                        >
                                            Order Now
                                        </a>
                                    </div>
                                    <div className="col-lg-6 text-center text-lg-end overflow-hidden">
                                        <img className="img-fluid spin-animation" src="SEEKH_KABABS-removebg-preview.png" alt="Seekh Kababs" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="carousel-item seekh-slide" data-bs-interval="3000">
                        <div className="slide-background">
                            <img src={bg1} alt="Seekh Kebab Slide Background" className="slide-bg-image" />
                        </div>
                        <div className="container-xxl py-5 hero-header mb-5 hero-header-transparent">
                            <div className="container my-5 py-5">
                                <div className="row align-items-center g-5">
                                    <div className="col-lg-6 text-center text-lg-start">
                                        <h1
  className="display-5 seekh-slide-text animated slideInLeft"
  style={{
    color: "white",
    WebkitTextStroke: "1px black", // adds black border
    textShadow: "2px 2px 4px rgba(0,0,0,0.6)", // optional for smooth shadow
  }}
>
  Taste the Best
  <br />
  Seekh Kebabs Unmatched Flavors
</h1>

<p
  className="seekh-slide-text animated slideInLeft mb-4 pb-2"
  style={{
    color: "white",
    WebkitTextStroke: "0.5px black",
    textShadow: "1px 1px 3px rgba(0,0,0,0.6)",
  }}
>
  Bringing you Exotic and Flavourful Seekh Kebabs.
  <br /> A perfect slide for your meals.
</p>

                                        <a
                                            href="https://frozen.dzyris.in/?guest=true&restaurantId=682db56b038ddec1b8527d1c"
                                            className="btn btn-primary py-sm-3 px-sm-5 me-3 animated slideInLeft"
                                        >
                                            Order Now
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="carousel-item zinger-slide" data-bs-interval="3000">
                        <div className="slide-background">
                            <img src={bg2} alt="Zinger Slide Background" className="slide-bg-image" />
                        </div>

                        <div className="container-xxl py-5 hero-header mb-5 hero-header-transparent">
                            <div className="container my-5 py-5">
                                <div className="row align-items-center g-5">
                                    <div className="col-lg-6 text-center text-lg-start">
                                        <h1 className="display-5 zinger-slide-text animated slideInLeft">
                                            Delicious
                                            <br />
                                            Zinger Burgers
                                        </h1>
                                        <p className="zinger-slide-text animated slideInLeft mb-4 pb-2">
                                            Experience the crunch and flavor of our Zinger Burgers.
                                            <br /> A treat for your taste buds.
                                        </p>
                                        <a
                                            href="https://frozen.dzyris.in/?guest=true&restaurantId=682db56b038ddec1b8527d1c"
                                            className="btn btn-primary py-sm-3 px-sm-5 me-3 animated slideInLeft"
                                        >
                                            Order Now
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="carousel-indicators">
        <button
            type="button"
            data-bs-target="#heroCarousel"
            data-bs-slide-to="0"
            className="active"
            aria-current="true"
            aria-label="Slide 1"
        ></button>
        <button
            type="button"
            data-bs-target="#heroCarousel"
            data-bs-slide-to="1"
            aria-label="Slide 2"
        ></button>
        <button
            type="button"
            data-bs-target="#heroCarousel"
            data-bs-slide-to="2"
            aria-label="Slide 3"
        ></button>
    </div>
            </div>

<div className="container-xxl py-5">
                <div className="container">
                    <div className="row g-4">
                        <div className="col-lg-3 col-sm-6 wow fadeInUp" data-wow-delay="0.1s">
                            <div className="service-item rounded pt-3">
                                <div className="p-4">
                                    <i className="fa fa-3x fa-user-tie text-primary mb-4"></i>
                                    <h5>Master Chefs</h5>
                                    <p>
                                        Crafting Culinary Excellence with Every Dish. Elevating Your Dining Experience with Unmatched Flavor and Artistry.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-sm-6 wow fadeInUp" data-wow-delay="0.3s">
                            <div className="service-item rounded pt-3">
                                <div className="p-4">
                                    <i className="fa fa-3x fa-utensils text-primary mb-4"></i>
                                    <h5>Quality Food</h5>
                                    <p>
                                        Crafted with the Finest Ingredients for Unmatched Flavor. Every Dish is a Celebration of Taste and Excellence.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-sm-6 wow fadeInUp" data-wow-delay="0.5s">
                            <div className="service-item rounded pt-3">
                                <div className="p-4">
                                    <i className="fa fa-3x fa-cart-plus text-primary mb-4"></i>
                                    <h5>Online Order</h5>
                                    <p>
                                        Conveniently Enjoy Your Favorite Meals with Just a Click. Fast, Easy, and Delivered to Your Doorstep for Ultimate Convenience.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-sm-6 wow fadeInUp" data-wow-delay="0.7s">
                            <div className="service-item rounded pt-3">
                                <div className="p-4">
                                    <i className="fa fa-3x fa-headset text-primary mb-4"></i>
                                    <h5>24/7 Service</h5>
                                    <p>
                                        Always Here to Meet Your Needs, Anytime, Day or Night. Reliable Support Around the Clock for Your Convenience and Peace of Mind.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

<div className="container-xxl py-5">
                <div className="container">
                    <div className="row g-5 align-items-center">
                        <div className="col-lg-6">
                            <div className="row g-3">
                                <div className="col-6 text-start">
                                    <img className="img-fluid rounded w-100 wow zoomIn" data-wow-delay="0.1s" src="Chicken Strips.png" alt="Chicken Strips" />
                                </div>
                                <div className="col-6 text-start">
                                    <img className="img-fluid rounded w-75 wow zoomIn" data-wow-delay="0.3s" src="Crispy Chicken Fillet.png" style={{ marginTop: '25%' }} alt="Crispy Chicken Fillet" />
                                </div>
                                <div className="col-6 text-end">
                                    <img className="img-fluid rounded w-75 wow zoomIn" data-wow-delay="0.5s" src="51UJxv24EAL-removebg-preview.png" alt="Chicken Nugget" />
                                </div>
                                <div className="col-6 text-end">
                                    <img className="img-fluid rounded w-100 wow zoomIn" data-wow-delay="0.7s" src="Chicken Popcorn.png" alt="Chicken Popcorn" />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <h5 className="section-title ff-secondary text-start text-primary fw-normal">About Us</h5>
                            <h1 className="mb-4">
                                Welcome to <i className="fa fa-utensils text-primary me-2"></i>Dzyris Frozen Foods
                            </h1>
                            <p className="mb-4">
                                Embark on a culinary journey with Dzyris Frozen Foods Pvt Ltd, where quality meets convenience to redefine your taste buds. We provide 100 % Halal food, we specialize in producing a wide variety of ready-to-eat meals and nutritious frozen packages.
                            </p>
                            <p className="mb-4">
                                Driven by a passion for excellence and a commitment to innovation, each Dzyris product promises guarantees unmatched taste and nutritional benefits. Our state-of-the-art facilities and meticulous quality assurance ensure that every bite exceeds expectations.
                            </p>
                            <p className="mb-4">
                                Join us in savoring the essence of frozen culinary artistry with Dzyris Frozen Foods Pvt Ltd- where every meal represents a perfect blend of flavor and convenience.
                            </p>
                            <div className="row g-4 mb-4">
                                <div className="col-sm-6">
                                    <div className="d-flex align-items-center border-start border-5 border-primary px-3">
                                        <h1 className="flex-shrink-0 display-5 text-primary mb-0" data-toggle="counter-up">
                                            5
                                        </h1>
                                        <div className="ps-4">
                                            <p className="mb-0">Years of</p>
                                            <h6 className="text-uppercase mb-0">Experience</h6>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-6">
                                    <div className="d-flex align-items-center border-start border-5 border-primary px-3">
                                        <h1 className="flex-shrink-0 display-5 text-primary mb-0" data-toggle="counter-up">
                                            500
                                        </h1>
                                        <div className="ps-4">
                                            <p className="mb-0">Happy</p>
                                            <h6 className="text-uppercase mb-0">Customers</h6>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <a className="btn btn-primary py-3 px-5 mt-2" href="about.html">
                                Read More
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            {/* Menu Section */}
            <div className="container-xxl py-5">
                <div className="container">
                    <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
                        <h5 className="section-title ff-secondary text-center text-primary fw-normal">Food Menu</h5>
                        <h1 className="mb-5">Most Popular Items</h1>
                    </div>
                    <div className="tab-class text-center wow fadeInUp" data-wow-delay="0.1s">
                        <ul className="nav nav-pills d-inline-flex justify-content-center border-bottom mb-5">
                            <li className="nav-item">
                                <a className="d-flex align-items-center text-start mx-3 ms-0 pb-3 active" data-bs-toggle="pill" href="#veg-menu">
                                    <i className="fa fa-coffee fa-2x text-primary"></i>
                                    <div className="ps-3">
                                        <small className="alt mb-0">Popular</small>
                                        <h6 className="mt-n1 mb-0">Vegetarian</h6>
                                    </div>
                                </a>
                            </li>
                            <li className="nav-item">
                                <a className="d-flex align-items-center text-start mx-3 pb-3" data-bs-toggle="pill" href="#non-veg-menu">
                                    <i className="fa fa-hamburger fa-2x text-primary"></i>
                                    <div className="ps-3">
                                        <small className="alt mb-0">Special</small>
                                        <h6 className="mt-n1 mb-0">Non-Vegetarian</h6>
                                    </div>
                                </a>
                            </li>
                            <li className="nav-item">
                                <a className="d-flex align-items-center text-start mx-3 me-0 pb-3" data-bs-toggle="pill" href="#seekh-kebab-menu">
                                    <i className="fa fa-utensils fa-2x text-primary"></i>
                                    <div className="ps-3">
                                        <small className="alt mb-0">New</small>
                                        <h6 className="mt-n1 mb-0">Seekh Kebab</h6>
                                    </div>
                                </a>
                            </li>
                            <li className="nav-item">
                                <a className="d-flex align-items-center text-start mx-3 me-0 pb-3" data-bs-toggle="pill" href="#best-seller-menu">
                                    <i className="fa fa-star fa-2x text-primary"></i>
                                    <div className="ps-3">
                                        <small className="alt mb-0">Our</small>
                                        <h6 className="mt-n1 mb-0">Best Sellers</h6>
                                    </div>
                                </a>
                            </li>
                        </ul>
                        <div className="tab-content">
                            {/* Veg Menu Start */}
                            <div id="veg-menu" className="tab-pane fade show p-0 active"> {/* Make sure one tab is 'active' */}
                                <div className="row g-4">
                                    {vegItems.map((item, index) => (
                                        <MenuItem
                                            key={index}
                                            image={item.image}
                                            name={item.name}
                                            price={item.price}
                                            description={item.description}
                                            quantity={item.quantity}
                                            orderLink={item.orderLink}
                                            onImageClick={handleImageClick} // Pass the handler here
                                        />
                                    ))}
                                </div>
                            </div>
                            {/* Veg Menu End */}

                            {/* Non-Veg Menu Start */}
                            <div id="non-veg-menu" className="tab-pane fade p-0">
                                <div className="row g-4">
                                    {nonVegItems.map((item, index) => (
                                        <MenuItem
                                            key={index}
                                            image={item.image}
                                            name={item.name}
                                            price={item.mrp} 
                                            description={item.description}
                                            quantity={item.weight_and_pieces} 
                                            orderLink={item.orderLink}
                                            onImageClick={handleImageClick} // Pass the handler here
                                        />
                                    ))}
                                </div>
                            </div>
                            {/* Non-Veg Menu End */}

                            {/* Seekh Kebab Menu Start */}
                            <div id="seekh-kebab-menu" className="tab-pane fade p-0">
                                <div className="row g-4">
                                    {seekhKebabItems.map((item, index) => (
                                        <MenuItem
                                            key={index}
                                            image={item.image}
                                            name={item.name}
                                            price={item.mrp} 
                                            description={item.description}
                                            quantity={item.weight_and_pieces} 
                                            orderLink={item.orderLink}
                                            onImageClick={handleImageClick} // Pass the handler here
                                        />
                                    ))}
                                </div>
                            </div>
                            {/* Seekh Kebab Menu End */}

                            {/* Best Seller Menu Start */}
                            <div id="best-seller-menu" className="tab-pane fade p-0">
                                <div className="row g-4">
                                    {bestSellerItems.map((item, index) => (
                                        <MenuItem
                                            key={index}
                                            image={item.image}
                                            name={item.name}
                                            price={item.mrp || item.price} 
                                            description={item.description}
                                            quantity={item.weight_and_pieces || item.quantity} 
                                            orderLink={item.orderLink}
                                            onImageClick={handleImageClick} // Pass the handler here
                                        />
                                    ))}
                                </div>
                            </div>
                            {/* Best Seller Menu End */}
                        </div>
                    </div>
                </div>
            </div>
            {/* Menu End */}

            {/* Image Modal */}
            <ImageModal
                imageUrl={modalImage}
                imageName={modalImageName}
                onClose={handleCloseModal}
            />

            <Footer />
        </>
    );
}

export default Dzyris;
